<template>
  <div v-if="isLoading">
    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
  </div>
  <div v-else>
    <basic-select
      :options="options"
      :isError="isError"
      :reload="reload"
      :isDisabled="isDisabled"
      :selected-option="item"
      @select="onSelect"
      :placeholder="placeholder"
    >
    </basic-select>
  </div>
</template>

<script>
import catalogService from '@/helpers/service/catalog-service'
import { BasicSelect } from 'vue-search-select'
import { StatusEnum } from '@/enum/status.enum.js'

export default {
  name: 'CatalogSelector',
  components: {
    'basic-select': BasicSelect,
  },
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isDefault: {
      type: Boolean,
      default: false,
    },
    reload: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => {
        return {
          text: null,
          value: null,
        }
      },
    },
    remove: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'กรุณาเลือก',
    },
    catalogTypeId: {
      type: String,
      default: '',
    },
  },
  mounted() {
    // this.onGetCatalogTypeSelector()
  },
  data() {
    return {
      options: [],
      item: {
        value: null,
        text: null,
      },
      isLoading: false,
    }
  },
  watch: {
    catalogTypeId: function(value) {
      if (value !== '') {
        this.options = []
        this.item = {
          value: '',
          text: '',
        }
        this.onGetCatalogSelector()
      } else {
        this.options = []
        this.item = {
          value: '',
          text: '',
        }
      }
    },
    defaultValue: function(value, oldVal) {
      if (value.value && value.text) {
        this.item = value
      }
    },
    reload: function(value) {
      if (value) {
        this.item = {
          value: null,
          text: null,
        }
      } else {
        this.onGetCatalogSelector()
      }
    },
    remove: function(value) {
      if (value) {
        this.onGetCatalogSelector()
      }
    },
    deep: true,
  },
  methods: {
    onSelect(item) {
      item.value =
        item.value === null || item.value === undefined ? '' : item.value
      item.text = item.text === null || item.text === undefined ? '' : item.text
      this.item = item
      this.$emit('selected', { value: item.value, text: item.text })
    },
    async onGetCatalogSelector() {
      try {
        this.isLoading = true
        this.options = []
        let params = new URLSearchParams()
        params.append('pageSize', 999999)
        params.append('type', this.catalogTypeId)
        params.append('sort', 'create_info.timestamp')
        params.append('status', StatusEnum.ACTIVE)
        params.append('status', StatusEnum.INACTIVE)
        let result = await catalogService.getCatalogMasterListAsync(params)
        if (result.status === 200) {
          result.data.items.forEach((element, index) => {
            this.options[index] = {
              value: element.id,
              text: element.display_name.en,
            }
          })
          if (this.remove) {
            this.options.forEach((element, index) => {
              if (element.value === this.remove) {
                this.options.splice(index, 1)
                console.log(index)
              }
            })
          }
        } else {
          if (result.response.data.message) {
            console.log(result.response.data.message)
          } else {
            console.log('Bad request: Unkonw error')
          }
        }
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        console.log('Error : ', err)
      }
    },
  },
}
</script>
